(() => {
  if (window.evProductCardSwatches) {
    window.evProductCardSwatches.schedule();
    return;
  }
  let frame = null;
  const update = () => {
    frame = null;
    document.querySelectorAll('.product-form-swatch__variants').forEach((container) => {
      const swatches = Array.from(container.querySelectorAll('.swatch'));
      const counter = container.querySelector('.swatch-counter');
      if (!swatches.length || !counter || !container.offsetWidth) return;
      const width = swatches[0].getBoundingClientRect().width;
      if (!width) return;
      const perRow = Math.max(1, Math.floor((container.offsetWidth + 5) / (width + 5)));
      const visible = swatches.length > perRow ? Math.max(1, perRow - 1) : swatches.length;
      counter.style.display = visible < swatches.length ? 'flex' : 'none';
      const number = counter.querySelector('.counter-number');
      if (number) number.textContent = swatches.length - visible;
      swatches.forEach((swatch, index) => {
        swatch.style.display = index < visible ? 'block' : 'none';
      });
    });
  };
  const schedule = () => {
    if (frame === null) frame = requestAnimationFrame(update);
  };
  window.evProductCardSwatches = { schedule };
  window.evProductCardSwatchesLoaded = true;
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('ev:cards-rendered', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();
